// useDrawerState.js — Centralized drawer state management for MealPlan
import { useState } from "react";

/**
 * Manages all drawer open/close states in the MealPlan component.
 * Keeps them in a single hook to reduce clutter in the main component.
 */
export const useDrawerState = () => {
  // Recipe detail drawer
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRecipe, setSelectedRecipe] = useState(null);

  // Grocery sidebar
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Alternatives drawer
  const [alternativesDrawerOpen, setAlternativesDrawerOpen] = useState(false);
  const [dislikedRecipe, setDislikedRecipe] = useState(null);
  const [alternativeRecipes, setAlternativeRecipes] = useState([]);

  // Remove all drawer
  const [removeAllDrawerOpen, setRemoveAllDrawerOpen] = useState(false);
  const [mealTypeToRemove, setMealTypeToRemove] = useState(null);

  // Remove recipe drawer
  const [removeRecipeDrawerOpen, setRemoveRecipeDrawerOpen] = useState(false);
  const [recipeToRemove, setRecipeToRemove] = useState(null);

  // Details drawer
  const [detailsDrawerOpen, setDetailsDrawerOpen] = useState(false);

  // Fresh Up drawer
  const [freshUpDrawerOpen, setFreshUpDrawerOpen] = useState(false);

  // Tries left drawer
  const [triesLeftDrawerOpen, setTriesLeftDrawerOpen] = useState(false);

  // Replace meal plan drawer
  const [replaceMealPlanDrawerOpen, setReplaceMealPlanDrawerOpen] = useState(false);

  // Login modal
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  return {
    drawerOpen,
    setDrawerOpen,
    selectedRecipe,
    setSelectedRecipe,
    sidebarOpen,
    setSidebarOpen,
    alternativesDrawerOpen,
    dislikedRecipe,
    alternativeRecipes,
    setAlternativeRecipes,
    setDislikedRecipe,
    setAlternativesDrawerOpen,
    removeAllDrawerOpen,
    mealTypeToRemove,
    setMealTypeToRemove,
    setRemoveAllDrawerOpen,
    removeRecipeDrawerOpen,
    recipeToRemove,
    setRemoveRecipeDrawerOpen,
    setRecipeToRemove,
    detailsDrawerOpen,
    setDetailsDrawerOpen,
    freshUpDrawerOpen,
    setFreshUpDrawerOpen,
    triesLeftDrawerOpen,
    setTriesLeftDrawerOpen,
    replaceMealPlanDrawerOpen,
    setReplaceMealPlanDrawerOpen,
    isLoginModalOpen,
    setIsLoginModalOpen,
  };
};
